document.addEventListener("DOMContentLoaded", () => {
    const dateBegin = document.getElementById('dateBegin');
    const dateEnd = document.getElementById('dateEnd');
    const datePriceDisplay = document.getElementById('datePriceDisplay');
    let firstSelected = false;
    let secondSelected = false;
    let dateBeginElement;
    let dateEndElement;
    let dateTemp;
    let calendarItems = document.querySelectorAll('.pdw-calendar-items');
    const bookingBtn = document.getElementById('booking_btn');
    const nbrSelected = document.getElementById('nbrSelected');
    nbrSelected.addEventListener('change', (e) => {
        bookingBtn.href = bookingBtn.href.replace(/adults=[0-9]/, 'adults=' + nbrSelected.value);
        console.log('test');
    });
    //
    calendarItems.forEach((el) => {
        el.addEventListener('click', function calendarDateClick(e) {
            e.preventDefault();
            if (!firstSelected) {
                dateBeginElement = e.target;
                e.target.classList.add('pdw-calendar-selected');
                dateBegin.innerHTML = dateBeginElement.dataset.dateDisplay;
                firstSelected = true;
            } else if (firstSelected && !secondSelected) {
                if (e.target.classList.contains('pdw-calendar-selected')) {
                    e.target.classList.remove('pdw-calendar-selected');
                    firstSelected = false;
                    dateBegin.innerHTML = '&nbsp;';
                } else {
                    dateEndElement = e.target;
                    if (dateBeginElement.dataset.date > dateEndElement.dataset.date) {
                        dateTemp = dateBeginElement;
                        dateBeginElement = dateEndElement;
                        dateEndElement = dateTemp;
                    }
                    e.target.classList.add('pdw-calendar-selected');
                    dateBegin.innerHTML = dateBeginElement.dataset.dateDisplay;
                    dateEnd.innerHTML = dateEndElement.dataset.dateDisplay;
                    secondSelected = true;
                    let beginSelected = false;
                    let lastSelected = false;
                    calendarItems.forEach((el) => {
                        if (beginSelected) {
                            if (el.dataset.date === dateEndElement.dataset.date) {
                                lastSelected = true;
                            } else if (!lastSelected) {
                                el.classList.add('pdw-calendar-selected');
                            }
                        } else if (el.dataset.date === dateBeginElement.dataset.date) {
                            beginSelected = true;
                        }

                    });
                    datePrice();
                    bookingBtn.href = 'https://www.secure-hotel-booking.com/d-edge/redirect/2YH1/'+document.documentElement.lang+'/RoomSelection?arrivalDate=' + dateBeginElement.dataset.date + '&departureDate=' + dateEndElement.dataset.date + '&adults=' + nbrSelected.value + '&children=0&infants=0&currency=EUR' + datePriceDisplay.dataset.rateId + datePriceDisplay.dataset.roomId;
                    console.log(bookingBtn);

                }
            } else if (firstSelected && secondSelected) {
                document.querySelectorAll('.pdw-calendar-selected').forEach((el) => {
                    el.classList.remove('pdw-calendar-selected');
                });
                secondSelected = false;
                dateEnd.innerHTML = '&nbsp;';
                dateBeginElement = e.target;
                e.target.classList.add('pdw-calendar-selected');
                dateBegin.innerHTML = dateBeginElement.dataset.dateDisplay;
                firstSelected = true;

            }
        });
    });
    let btnReset = document.getElementById('btn-reset');
    btnReset.addEventListener('click', function reset(e) {
        document.querySelectorAll('.pdw-calendar-selected').forEach((el) => {
            el.classList.remove('pdw-calendar-selected');
        });
        secondSelected = false;
        firstSelected = false;
        dateEnd.innerHTML = '&nbsp;';
        dateBegin.innerHTML = '&nbsp;';
        datePriceDisplay.innerHTML = '&nbsp;';
    });

    async function datePrice() {
        //Textes
        const textPriceUnavailable = {
            "fr-FR": "Pas de disponibilté",
            "en-US": "No availability",
            "nl-NL": "Geen beschikbaarheid"
        }
        let pageLang = document.documentElement.lang;
        let date1 = new Date(dateBeginElement.dataset.date);
        let date2 = new Date(dateEndElement.dataset.date);
        let Difference_In_Time = date2.getTime() - date1.getTime();
        let nbrNight = Difference_In_Time / (1000 * 3600 * 24);
        let fetchUrl = window.location.protocol + '//' + window.location.hostname + '/dedge/stay_planning/parser.php?dateBegin=' + dateBeginElement.dataset.date + '&nbrNight=' + nbrNight + datePriceDisplay.dataset.rateId + datePriceDisplay.dataset.roomId;
        const response = await fetch(fetchUrl);
        const price = await response.json();
        console.log(price);
        if (price.result) {
            if (price.price > 0) {
                datePriceDisplay.innerHTML = price.price + '€';
            } else {
                datePriceDisplay.innerHTML = textPriceUnavailable[pageLang];
            }
        }
    }
});

